import { useNavigate } from 'react-router-dom';
import { CTAButton } from '../components/CTAButton';
import { LegalFooter } from '../components/LegalFooter';

export function HookScreen() {
  const nav = useNavigate();
  return (
    <div className="lume-bg min-h-svh flex flex-col px-6 py-8">
      <div className="flex justify-center pt-3">
        <div className="flex flex-col items-center gap-1.5">
          <span className="lume-eyebrow text-accent" style={{ letterSpacing: '0.4em' }}>
            LUMÉ
          </span>
          <div className="w-6 h-px bg-accent-dim" />
        </div>
      </div>

      <div className="mt-14 animate-[hookin_0.6s_ease]">
        <h1
          className="font-extrabold"
          style={{ fontSize: 'clamp(40px, 12vw, 56px)', lineHeight: 1.05, letterSpacing: '-0.02em' }}
        >
          <span className="text-text block">How old is</span>
          <span className="text-text block">your skin,</span>
          <span className="text-accent block">really?</span>
        </h1>
        <p className="text-body text-text-secondary mt-5 leading-relaxed">
          AI analysis of 47 skin markers.
          <br />
          Your result in seconds.
        </p>
      </div>

      <div className="flex-1" />

      <div className="h-px bg-accent-dim/40 mb-7" />

      <CTAButton label="Scan My Skin" onClick={() => nav('/age')} />
      <p className="text-caption text-text-tertiary text-center mt-3 mb-4">
        No account required
      </p>

      <LegalFooter />

      <style>{`@keyframes hookin { from { opacity: 0; transform: translateY(8px) } to { opacity: 1; transform: none } }`}</style>
    </div>
  );
}
